<template>
    <SidebarLayout v-if="selfActiveOrganization">
        <template #sidebar>
            <OrganizationSidebar :organization="selfActiveOrganization" />
        </template>
        <template #main>
            <router-view :organization="selfActiveOrganization" />
        </template>
    </SidebarLayout>
</template>

<script>
import { mapGetters } from 'vuex'
import { SidebarLayout } from '@/components/ui/layouts'
import OrganizationSidebar from '@/partials/sidebars/OrganizationSidebar.vue'


export default {
    name: 'OrganizationPage',

    components: {
        OrganizationSidebar,
        SidebarLayout,
    },

    computed: {
        ...mapGetters(['selfActiveOrganization']),
    },
}
</script>
